import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { FormGroup, Label, Collapse, Modal, ModalBody } from 'reactstrap';

import Aux from '../../../system/containers/Aux';
import TextInput from '../../../system/fields/TextInput';
import * as validations from '../../../system/utils/Validation';
import Wysiwyg from '../../../system/fields/Wysiwyg';

class DestinationLegs extends Component {
  constructor(props, leg, index, fields) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.toggleHotel = this.toggleHotel.bind(this);
    this.toggleCity = this.toggleCity.bind(this);
    this.state = {
      collapse: true,
      hotelToggle: false,
      cityToggle: false,
    };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  toggleCity() {
    this.setState({
      cityToggle: !this.state.cityToggle,
    });
  }

  toggleHotel() {
    this.setState({
      hotelToggle: !this.state.hotelToggle,
    });
  }

  render() {
    const { props } = this;
    const { leg, formValues } = props;
    const { options } = formValues

    const defaultGuideValue = formValues && formValues.options && formValues.options[this.props.OIndex] &&  formValues.options[this.props.OIndex].legs && formValues.options[this.props.OIndex].legs[this.props.CLIndex] &&    formValues.options[this.props.OIndex].legs[this.props.CLIndex].guide[this.props.index]
    return (
      <Aux>
        {!this.state.collapse && (
          <div className='toggle' onClick={this.toggle}>
            <i className='fas fa-eye' /> <span>Expand</span>
          </div>
        )}
        {this.state.collapse && (
          <div className='toggle' onClick={this.toggle}>
            <i className='fas fa-eye-slash' /> <span>Collapse</span>
          </div>
        )}

        <Collapse isOpen={this.state.collapse}>
          <div className={'row'}>
            <div className={'col-8'}>
              <Label>Title</Label>
              <Field
                defaultValue={defaultGuideValue && defaultGuideValue.title &&  defaultGuideValue.title}
                name={`${leg}.title`}
                component={TextInput}
                validate={validations.required}
              />
            </div>
            <div className={'col-4'}>
              <Label>Day From - To</Label>
              <Field
                // defaultValue={formValues + '.' + leg + '.day_from_to'}
                defaultValue={defaultGuideValue && defaultGuideValue.day_from_to &&  defaultGuideValue.day_from_to}

                name={`${leg}.day_from_to`}
                component={TextInput}
                // validate={validations.required}
              />
            </div>
          </div>
          {/* <div className={'row'}>
            <div className={'col-12'}>
              <Label>Description</Label>
              <Field name={`${leg}.description`} component={Wysiwyg}       defaultValue={defaultGuideValue && defaultGuideValue.description &&  defaultGuideValue.description}/>
            </div>
          </div> */}
          {/* <div className={'row'}>
            <div className={'col-12'}>
              <Label>Fine Print</Label>
              <Field name={`${leg}.fine_print`} component={Wysiwyg}   defaultValue={defaultGuideValue && defaultGuideValue.fine_print &&  defaultGuideValue.fine_print} />
            </div>
          </div> */}
        </Collapse>
      </Aux>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    hotels: state.overview.hotels,
    cities: state.overview.cities,
  };
};

export default connect(mapStateToProps)(DestinationLegs);



// WEBPACK FOOTER //
// ./src/containers/Deals/components/Guide.jsx